<mat-button-toggle-group 
    class="bulk-edit-toggle"
    appearance="legacy"
    [value]="value"
    [disabled]="disabled"
    (change)="onValueChange($event.value)">
    <mat-button-toggle class="unchanged" [value]="unchangedValue">
        <mat-icon svgIcon="minus"></mat-icon>
    </mat-button-toggle>
    @for (option of options; track option.value) {
        <mat-button-toggle [value]="option.value">{{ option.label }}</mat-button-toggle>
    }
</mat-button-toggle-group>
